import { EventData } from './contracts';

const sendBeacon = (url: string, data: EventData) => {
  const headers = {
    // Hack for sendBeacon to work. Should be 'application/json'.
    type: 'text/plain',
  };

  const blob = new Blob([JSON.stringify(data)], headers);
  // Note: this will return a 400 if any of the required fields aren't present, such as BCID or Carvana user ID.
  navigator.sendBeacon(url, blob);
};

export default sendBeacon;
